import { useQuery } from '@maui/react-query'
import { useVTApiClient } from './client'

// TODO: this should be moved somewhere else
export const INDICATOR_KEYS = {
  FILES_OPENED: 'files_opened',
  FILES_WRITTEN: 'files_written',
  FILES_DELETED: 'files_deleted',
  FILES_ATTR_CHANGED: 'files_attribute_changed',
  PROCESSES_CREATED: 'processes_created',
  PROCESSES_TERMINATED: 'processes_terminated',
  PROCESSES_KILLED: 'processes_killed',
  PROCESSES_INJECTED: 'processes_injected',
  MUTEXES_OPENED: 'mutexes_opened',
  MUTEXES_CREATED: 'mutexes_created',
  REGISTRY_KEYS_OPENED: 'registry_keys_opened',
  REGISTRY_KEYS_SET: 'registry_keys_set',
  REGISTRY_KEYS_DELETED: 'registry_keys_deleted',
  DNS_LOOKUPS: 'dns_lookups',
  IP_TRAFFIC: 'ip_traffic',
  HTTP_CONVERSATIONS: 'http_conversations'
}

export const useGetPrivateFileBehavioursQuery = ({ id }, options = {}) => {
  const api = useVTApiClient('privateFiles')

  return useQuery({
    queryFn: () => api.behaviours({ id }),
    queryKey: ['file', 'behaviours', id],
    select: ({ data }) => {
      // return a subset of all the properties returned by VT which make sense for MATI
      return Object.fromEntries(
        Object.entries(data).filter(([key]) => Object.values(INDICATOR_KEYS).includes(key))
      )
    },
    ...options,
    enabled: id !== undefined && options.enabled !== false,
  })
}
